@if (isVisible()) {
  <div class="ios-install-nudge flex items-center justify-between gap-3 bg-purple-500 px-4 py-2.5 text-xs text-white">
    <p class="m-0">
      Install Match15 for live goal alerts. Tap
      <mat-icon
        class="ios-install-nudge__icon"
        aria-hidden="true"
        fontIcon="ios_share"
        fontSet="material-symbols-outlined"
      >ios_share</mat-icon>
      icon, then <strong>Add to Home Screen</strong>.
    </p>
    <button
      type="button"
      class="ios-install-nudge__dismiss shrink-0 cursor-pointer bg-transparent p-1 text-white"
      aria-label="Dismiss"
      (click)="dismiss()"
    >
      &#10005;
    </button>
  </div>
}
